import { UserStatusEnum } from 'src/shared/enums';
import { IConAccountData, IUser } from 'src/shared/models';
import { customRegexName, mailRegexConsumer } from 'utils';

export const checkConRegisterForm = (accountData: IConAccountData): boolean => {
  return Boolean(
    accountData.email.match(mailRegexConsumer) &&
      accountData.password?.length > 0 &&
      accountData.isValidPassword &&
      accountData.name.match(customRegexName) &&
      accountData.surname.match(customRegexName) &&
      accountData.birthday != '' &&
      accountData.terms
  );
};

export const getConUserStatus = (user: IUser) => {
  return user ? UserStatusEnum.ACCEPTED_EMPLOYEE : UserStatusEnum.DENIED;
};
